import React, { useMemo } from "react";
import { PromotionSummary } from "web/react/components/promotion-summary/promotion-summary";
import { Promotion } from "web/react/components/promotion/promotion";
import { RetailerPromotionsSerializer } from "web/types/serializers";
import * as styles from "./promotion-header.css";

interface PromotionHeaderProps {
    promotions: RetailerPromotionsSerializer;
    parentArea: "header" | "modal" | "product_details" | "compare_prices";
    title: string;
    onClick: () => void;
    retailerNetwork: string | null;
}

export function PromotionHeader({
    promotions,
    parentArea,
    title,
    onClick,
    retailerNetwork,
}: PromotionHeaderProps): React.ReactElement | null {
    const analytics = useMemo(
        () => ({
            clicked: [
                {
                    retailer_network: retailerNetwork,
                },
            ],
            impression: [
                {
                    retailer_network: retailerNetwork,
                },
                {
                    parent_area: parentArea,
                },
            ],
        }),
        [retailerNetwork, parentArea]
    );

    const activePromotions = promotions.active_promotions ?? [];
    const expiredPromotions = promotions.expired_promotions ?? [];

    if (activePromotions.length === 0) {
        return null;
    }

    if (activePromotions.length === 1 && expiredPromotions.length === 0) {
        const promo = activePromotions[0];

        return (
            <div className={styles.wideCardPromo} data-testid="single-promo">
                <Promotion
                    pageType="storefront"
                    message={promo.description}
                    promoCode={promo.discount_code}
                    expirationDateTimestamp={promo.expiration_date}
                    promoAnalyticsItemData={analytics}
                    isActive={true}
                />
            </div>
        );
    }

    return (
        <PromotionSummary
            promotions={promotions}
            title={title}
            onClick={onClick}
            retailerNetwork={retailerNetwork}
        />
    );
}
